import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';

import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

import AppWrapper from '../../components/appWrapper/appWrapper';
import { Testimoninal } from '../../components/testimoninal/testimoninal';
import useScrollToLocation from '../../hooks/useScrollToLocation';
import { generateReviewSchema } from '../../lib/utils/generateReviewSchema';
import { FeaturesNavigation } from './components/featuresNavigation/featuresNavigation';
import { FeaturesSection } from './components/featuresSection/featuresSection';
import HeroSection from './components/heroSection/heroSection';
import { SignUpProcess } from './components/signUpProcess/signUpProcess';
import { FeaturesTestimoninal } from './components/testimoninal/testimoninal';

const groomersReviews = [
  {
    body: 'Pata’s great for managing new clients, and super handy for regulars when I can’t get to the phone. I love the online booking option: It’s simple, quick, and it just works. Huge time-saver for both myself and my customers!',
    name: 'Leigh Butcher - Whitegates Grooming Parlour',
    date: '2025-05-01',
  },
  {
    body: 'My favourite feature is that clients can leave reviews about my services. The platform is very easy to use, and the team is always there - you never feel like you’re left on your own. Pata has been amazing for my business!',
    name: "Amanda Coverdale, Pet Groomer at Mia's Paw Spa",
    date: '2025-05-01',
  },
];

export const LearnMoreButton = () => {
  const navigate = useNavigate();

  const handleNavigateToPataPay = () => {
    navigate('/business/pata-pay');
  };

  return <Button onClick={handleNavigateToPataPay}>Learn more</Button>;
};

export const BusinessFeatures = () => {
  useScrollToLocation();

  const reviewSchema = generateReviewSchema(groomersReviews);

  return (
    <>
      <Helmet>
        <title>Pata | Pet Grooming Booking Software To Run Your Business</title>
        <meta
          name="description"
          content="Minimise no-shows, simplify admin and enable online bookings with Pata – the pet grooming software designed to streamline your business."
        />
        <script type="application/ld+json">{JSON.stringify(reviewSchema)}</script>
      </Helmet>
      <AppWrapper>
        <HeroSection />
        <WidthContainer />
        <FeaturesNavigation />

        {/* <TopFeatures /> */}
        <FeaturesSection />

        {/* <PataPay /> */}

        {/* <BusinessBenefits /> */}
        {/* <PaidFeatures /> */}

        <FeaturesTestimoninal />

        <SignUpProcess />

        {/* <Faqs />
        <FollowUs /> */}
      </AppWrapper>
    </>
  );
};
